import React from 'react';

var ArrowLeft = function ArrowLeft(_ref) {
  var _ref$id = _ref.id,
      id = _ref$id === void 0 ? "i-arrow-left" : _ref$id,
      className = _ref.className,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 32 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 32 : _ref$height,
      _ref$strokeWidth = _ref.strokeWidth,
      strokeWidth = _ref$strokeWidth === void 0 ? '6.25%' : _ref$strokeWidth,
      _ref$strokeLinejoin = _ref.strokeLinejoin,
      strokeLinejoin = _ref$strokeLinejoin === void 0 ? 'round' : _ref$strokeLinejoin,
      _ref$strokeLinecap = _ref.strokeLinecap,
      strokeLinecap = _ref$strokeLinecap === void 0 ? 'round' : _ref$strokeLinecap,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentcolor' : _ref$color;
  return React.createElement("svg", {
    className: className,
    id: id,
    viewBox: "0 0 32 32",
    width: width,
    height: height,
    fill: "none",
    stroke: color,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeWidth: strokeWidth
  }, React.createElement("path", {
    d: "M10 6 L2 16 10 26 M2 16 L30 16"
  }));
};

export default ArrowLeft;